<template><span class="k-num-score" :class="_skin">{{text}}{{unitName}}</span></template>

<script>
    import {isString} from '../../common/utils'
    export default {
        name: 'k-num-score',
        props: ['value', 'skin', 'unit'],
        computed: {
            unitName() {
                const {unit} = this
                return unit === true ? '分' : isString(unit) ? unit : ''
            },
            _skin() {
                const {skin} = this
                return isString(skin) ? skin : skin === false ? '' : 'red'
            },
            text() {
                const {value} = this
                return value >= 0 ? +value : '无效'
            }
        }
    };
</script>
